import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./NumberInput.scss";
import { useField } from "formik";
import IconPlus from "app/pages/.shared/static/icons/IconPlus";
import IconMinus from "app/pages/.shared/static/icons/IconMinus";

const NumberInputFormik = props => {
	const { id, canIncrement, canDecrement, onChange = () => {} } = props;
	const [field, , helpers] = useField(props);

	const decrement = useCallback(() => {
		const newValue = Number(field.value) - 1;
		helpers.setValue(newValue);
		onChange(newValue);
	}, [field.value]);

	const increment = useCallback(() => {
		const newValue = Number(field.value) + 1;
		helpers.setValue(newValue);
		onChange(newValue);
	}, [field.value]);

	const numberInputIncrementClass = classNames({
		"number-input__button": true,
		"number-input__button--disabled": !canIncrement(field.value),
	});

	const numberInputDecrementClass = classNames({
		"number-input__button": true,
		"number-input__button--disabled": !canDecrement(field.value),
	});

	return (
		<div className="number-input">
			<button
				type="button"
				className={numberInputDecrementClass}
				onClick={canDecrement(field.value) ? decrement : undefined}
				data-testid={`number-input-${id}-decrement`}
			>
				<IconMinus width={10} height={10} />
			</button>
			<input
				value={field.value}
				disabled
				className="number-input__input"
				id={id}
				type="number"
				data-testid={`number-input-${id}-input`}
			/>
			<button
				type="button"
				className={numberInputIncrementClass}
				onClick={canIncrement(field.value) ? increment : undefined}
				data-testid={`number-input-${id}-increment`}
			>
				<IconPlus width={10} height={10} />
			</button>
		</div>
	);
};

NumberInputFormik.defaultProps = {
	canIncrement: () => true,
	canDecrement: value => {
		return value !== 0;
	},
};

NumberInputFormik.propTypes = {
	id: PropTypes.string,
	canIncrement: PropTypes.func,
	canDecrement: PropTypes.func,
	onChange: PropTypes.func,
};

export default memo(NumberInputFormik);
